import React from 'react';
import PropTypes from 'prop-types';
import Helmet from 'react-helmet';

import Header from '../components/header';
import Footer from '../components/footer';

const Layout = ({ children, data }) => (
    <div>
        <Helmet
            title={data.site.siteMetadata.title}
            meta={[
                { name: 'description', content: 'Mobile, Desktop & Web Software Development | KentWeb' },
                { name: 'theme-color', content: '#13418b' },
                { name: 'apple-mobile-web-app-status-bar-style', content: '#13418b' },
            ]}
        >
            <link rel="canonical" href="https://kentweb.co.uk/" />
            <link rel="icon" type="image/png" href="/favicon.ico" />

            
            <link rel="stylesheet" type="text/css" href="../css/layout.css" />
            <link rel="stylesheet" type="text/css" href="https://cdnjs.cloudflare.com/ajax/libs/twitter-bootstrap/4.1.3/css/bootstrap.min.css" />
            <script async src="https://cdnjs.cloudflare.com/ajax/libs/jquery/3.3.1/jquery.slim.min.js" />
            <script async src="https://cdnjs.cloudflare.com/ajax/libs/twitter-bootstrap/4.1.3/js/bootstrap.min.js" />
        </Helmet>
        <Header siteTitle={data.site.siteMetadata.title} />
        <main>
            {children()}
        </main>
        <Footer />

        <script async src="https://www.googletagmanager.com/gtag/js?id=UA-107294732-1" />
        <script
            dangerouslySetInnerHTML={{
                __html: `
                    window.dataLayer = window.dataLayer || [];
                    function gtag(){dataLayer.push(arguments); }
                    gtag('js', new Date());
                    gtag('config', 'UA-107294732-1');
                `,
            }} />
    </div>
);

export default Layout;

export const query = graphql`
  query SiteTitleQuery {
            site {
        siteMetadata {
            title
        }
        }
      }
    `;



// WEBPACK FOOTER //
// ./src/layouts/index.js